/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import React from 'react';
import Advertisement from './../Advertisement';

/**
 * Component that is used for rendering list of advertisement on the sidebar
 * Position description you can found there:
 * https://docs.google.com/spreadsheets/d/1A3s9YjyVhmBcrh5kMl8i2P3RJEyAcUhmwwthISf4gl8/edit#gid=834985875
 * Active position is determined by backend preloaded state
 * @see advertisement.reducer.js
 */
function AdvertisementList() {
    return (
        <div>
            <Advertisement position={9} />
            <Advertisement position={3} />

            <Advertisement position={10} />
            <Advertisement position={11} />
            <Advertisement position={12} />
            <Advertisement position={13} />
            <Advertisement position={14} />
            <Advertisement position={32} />
            <Advertisement position={33} />
            <Advertisement position={34} />

            <Advertisement position={16} />
            <Advertisement position={17} />
            <Advertisement position={18} />
            <Advertisement position={19} />
            <Advertisement position={20} />
            <Advertisement position={21} />
            <Advertisement position={22} />
            <Advertisement position={23} />
            <Advertisement position={24} />
            <Advertisement position={25} />
            <Advertisement position={26} />

            <Advertisement position={4} />

            <Advertisement position={42} />
        </div>
    );
}

export { AdvertisementList as default };



// WEBPACK FOOTER //
// ./src/js/AdvertisementList/AdvertisementList.js